import { useTranslation } from "react-i18next";
import { Button, MainModal, Typography, Form, message, Row, Col } from "../../ui/ot";
import DepartmentDepthStaffForm from "./department_depth_staff_form";
import { useState } from "react";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";

const DepartmentDepthStaffModal = ({
    keyPrefix = 'organization_structure.department',
    propsOpen,
    propsSetOpen,
    propsForm,
    onOK = () => { }
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [modalOpen_, setModalOpen_] = useState(false)
    const [modalOpen, setModalOpen] = [propsOpen ?? modalOpen_, propsSetOpen ?? setModalOpen_]
    const [modalLoading, setModalLoading] = useState(false)

    const [form_] = Form.useForm();
    const form = propsForm ?? form_

    const [axiosMode, setAxiosMode] = useState("get")
    const onFormFinish = (values) => {
        let formValues = form.getFieldsValue()
        formValues = {
            ...formValues,
            single: true
        }
        patchData([formValues])
        setModalOpen(false)
        form.resetFields()
        onOK()
    }

    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "get") {
            } else if (axiosMode === "post") {
                message.success("新增成功");
            } else if (axiosMode === "patch") {
                message.success("修改成功");
            } else if (axiosMode === "delete") {
                message.success("刪除成功");
            }
        } else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗");
            } else if (axiosMode === "patch") {
                message.error("修改失敗");
            } else if (axiosMode === "delete") {
                message.error("刪除失敗");
            }
        }
    }

    const {
        patchData
    } = useCRUDController({
        apiRoute: '/organization_structure/api/department_depth',
        onFinish
    })

    return <>
        <MainModal
            axiosMode={axiosMode}
            propsOpen={modalOpen}
            propsSetOpen={setModalOpen}

            propsForm={form}

            propsLoading={modalLoading}
            propsSetLoading={setModalLoading}

            onFinish={onFormFinish}
            formElement={<DepartmentDepthStaffForm
            />}
            width={1000}
        />
    </>
}

const DepartmentDepthStaffButton = ({
    handleOnClick = () => { },
    value
}) => {
    return <>
        <Row gutter={[8, 8]} style={{ display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
            <Col>
                <Button
                    style={{
                        backgroundColor: "#7FA1C3",
                    }}
                    onClick={handleOnClick}>
                    綁定人員
                </Button>
            </Col>
            <Col>
                {<Typography.P>
                    已綁定{(value || []).length}位
                </Typography.P>}
            </Col>
        </Row>

    </>
}

const useDepartmentDepthStaff = ({

}) => {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const handleOnClick = () => {
        setOpen(true)
    }
    return {
        open,
        setOpen,
        DepartmentDepthStaffModal,
        DepartmentDepthStaffButton,
        handleOnClick,
        form,
    }
}
export { useDepartmentDepthStaff }